import { useEffect, useState } from 'react';
import { isEmpty } from 'underscore';
import { ICountry, IState } from '../../../../types/api';
import useHomeStore from '../../../../store/homeStore';
import useAuthStore from '../../../../store/authStore';

export default function useBillingAddress() {
  const countryList = useHomeStore(state => state.countryList);
  const userProfile = useAuthStore(state => state.userProfile);
  const [billingAddress, setBillingAddress] = useState('');

  useEffect(() => {
    let address = '';
    if (userProfile && !isEmpty(userProfile)) {
      const usersCountry = countryList.find(
        (country: ICountry) => country.id === userProfile.countryId
      );
      if (usersCountry !== undefined) {
        let cityState = userProfile.city;
        if (userProfile.stateId && !isEmpty(usersCountry.states)) {
          const usersState = usersCountry.states.find(
            (state: IState) => state.id === userProfile.stateId
          );
          if (usersState !== undefined) {
            cityState += ',' + usersState.name;
          }
        }
        address = userProfile.address1;
        userProfile.address2 && userProfile.address2.trim()
          ? (address += '||' + userProfile.address2)
          : (address += '||null');
        userProfile.address3 && userProfile.address3.trim()
          ? (address += '||' + userProfile.address3)
          : (address += '||null');
        address +=
          '||' +
          cityState +
          '||' +
          userProfile.zipcode +
          '||' +
          usersCountry.name;
      }
    }
    setBillingAddress(address);
  }, [userProfile, countryList]);

  return { billingAddress };
}
